export const SESSION_TOKEN_KEY = 'token';

export const getSessionToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return sessionStorage.getItem(SESSION_TOKEN_KEY) ?? localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setSessionToken = (token: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(SESSION_TOKEN_KEY, token);
  localStorage.removeItem(SESSION_TOKEN_KEY);
};

export const clearSessionToken = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(SESSION_TOKEN_KEY);
};
